export const addAlertRespondersToFollowUpBulkActionType = 'addAlertRespondersToFollowUp';
